import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import MenuPopover from '../MenuPopover.js'

import {
  ComponentModsProps,
} from '../types.js';

export default function Mods(props:ComponentModsProps) {
  return (
    <MenuPopover changed={props.changed} title="Mod">
      <Box sx={{ margin: 4, width: 300 }}>
        {props.gamesAvailable &&
          <FormGroup>
            <Button
              variant="outlined"
              onClick={(e)=>props.valueChanged([])}>
              Deselect all
            </Button>
            <Button
              variant="outlined"
              onClick={(e)=>props.valueChanged(props.gamesAvailable.game_id)}>
              Select all
            </Button>
            {props.gamesAvailable.game_id && props.gamesAvailable.game_name.map((child, index) =>
              <FormControlLabel
                key={child}
                control={<Checkbox
                            checked={props.gamesChecked.some((x) => props.gamesAvailable.game_id[index]===x)} 
                            onChange={(e)=>props.valueChanged(props.gamesAvailable.game_id[index])}
                        />}
                label={child}
              />
            )}
          </FormGroup>
        }
      </Box>
    </MenuPopover>
  )
}

Mods.propTypes = {
  changed: PropTypes.bool,
  gamesChecked: PropTypes.array,
  gamesAvailable: PropTypes.object,
  valueChanged: PropTypes.func,
};
